import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { FileText, ShoppingCart, Lightning } from '@phosphor-icons/react';
import BookingsPage from './BookingsPage';
import BulkBookingPage from './BulkBookingPage';

// Original Assigned Files content as a separate component
import AssignedFilesContent from './AssignedFilesContent';

const TABS = [
  { id: 'files', label: 'Assigned Files', icon: FileText },
  { id: 'bookings', label: 'Booking History', icon: ShoppingCart },
  { id: 'bulk', label: 'Bulk Entry', icon: Lightning },
];

export default function StaffAssignedFilesPage() {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('files');
  const isStaff = user?.role === 'staff';

  return (
    <div className="space-y-4" data-testid="staff-assigned-files-page">
      {/* Tab Navigation — Only show for staff */}
      {isStaff && (
        <div className="flex gap-1 border-b border-gray-200 -mb-2">
          {TABS.map(tab => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                  isActive
                    ? 'border-[#002FA7] text-[#002FA7]'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
                data-testid={`tab-${tab.id}`}
              >
                <Icon size={18} />
                {tab.label}
              </button>
            );
          })}
        </div>
      )}

      {/* Tab Content */}
      <div>
        {activeTab === 'files' && <AssignedFilesContent />}
        {activeTab === 'bookings' && <BookingsPage embedded />}
        {activeTab === 'bulk' && <BulkBookingPage embedded />}
      </div>
    </div>
  );
}
